import script from "./PurchasedKnowledge.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchasedKnowledge.vue?vue&type=script&setup=true&lang=js"

import "./PurchasedKnowledge.vue?vue&type=style&index=0&id=9f0507c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f0507c8"]])

export default __exports__